<img class="logo" src="images/index/logo.png">

<style>
    img.logo {
        width: 66px;
        height: 15px;
    }
</style>
